const styles = {
    goBackWrapper: {
        padding: "0",
        margin: "0",
        display: "flex",
        marginLeft: "4.8vw",
        paddingTop: "7px"
    },
    goBackText: {
        padding: "0",
        margin: "0",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "24px",
        color: "#000000",
        textAlign: "center",
        width: "19.73vw",
        marginLeft: "4.53vw"
    },
    errorHeader: {
        marginTop: "184px",
        width: "78.93vw",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "20px",
        lineHeight: "24px",
        textAlign: "center",
        color: "#000000",
        marginLeft: "10.66vw"
    },
    errorMessage: {
        padding: "0",
        margin: "0",
        marginTop: "8px",
        marginLeft: "10.66vw",
        width: "78.93vw",
        fontFamily: "Roboto",
        fontStyle: 'normal',
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        textAlign: "center",
        letterSpacing: "0.1px",
        color: "#818C99"
    },
    repeatButton: {
        backgroundColor: "#06844D",
        borderRadius: "8px",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "15px",
        lineHeight: "20px",
        letterSpacing: "0.2px",
        color: "#FFFFFF",
        width: "29.33vw",
        marginLeft: "35.33vw",
        height: "36px",
        marginTop: "24px"
    }
}

export default styles;